import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppVideoMyWayPage } from './app-video-my-way';
import {ComponentsModule} from "../../components/components.module";
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppVideoMyWayPage,
  ],
    imports: [
        IonicPageModule.forChild(AppVideoMyWayPage),
        ComponentsModule,
        PipesModule,
    DirectivesModule,

    ],
})
export class AppVideoMyWayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-video-my-way/app-video-my-way.module.ts